<template>
  <div class="batch-share-page">
    <!-- 头部 -->
    <div class="header">
      <div class="header-content">
        <div class="wholesaler-info" v-if="wholesaler">
          <div class="avatar">{{ (wholesaler.companyName || '批').charAt(0) }}</div>
          <div class="info">
            <div class="name">{{ wholesaler.companyName || '批发商' }}</div>
            <div class="desc">{{ $t('public.BatchShareView.line10_text') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="product-list" v-if="products.length > 0">
      <div class="product-card" v-for="product in products" :key="product.id">
        <div class="product-image" @click="viewProduct(product)">
          <img :src="getImageUrl(product.image)" :alt="product.name" v-if="product.image" />
          <div class="no-image" v-else>📦</div>
        </div>
        <div class="product-info" @click="viewProduct(product)">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-desc">{{ product.description || '暂无描述' }}</div>
          <div class="product-meta">
            <span class="unit">{{ product.unit || '件' }}</span>
            <span class="stock">库存: {{ product.availableStock || 0 }}</span>
          </div>
          <div class="product-price">
            <div class="price-row">
              <span class="label">{{ $t('public.BatchShareView.line32_text') }}</span>
              <span class="price market">¥{{ product.marketPrice ? product.marketPrice.toFixed(2) : '0.00' }}</span>
            </div>
            <div class="price-row" v-if="product.wholesalePrice">
              <span class="label">{{ $t('public.BatchShareView.line36_text') }}</span>
              <span class="price wholesale">¥{{ product.wholesalePrice ? product.wholesalePrice.toFixed(2) : '0.00' }}</span>
            </div>
          </div>
        </div>
        <div class="product-action">
          <button class="btn-order" @click.stop="handleOrder(product)">{{ $t('public.BatchShareView.line42_text') }}</button>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-else-if="!loading">
      <div class="empty-icon">📦</div>
      <div class="empty-text">{{ $t('common.noProduct') }}</div>
    </div>

    <!-- 加载状态 -->
    <div class="loading-state" v-if="loading">
      <div class="spinner"></div>
      <div class="loading-text">{{ $t('common.loading') }}</div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import { getImageUrl } from '@/utils/image'

export default {
  name: 'BatchShareView',
  data() {
    return {
      batchCode: '',
      products: [],
      wholesaler: null,
      loading: true
    }
  },
  async mounted() {
    this.batchCode = this.$route.params.batchCode
    await this.loadBatchData()
  },
  methods: {
    getImageUrl,
    async loadBatchData() {
      try {
        this.loading = true
        const response = await api.get(`/share/batch/${this.batchCode}`)
        this.products = response.products || []
        this.wholesaler = response.wholesaler || null
      } catch (error) {
        console.error('加载批量分享数据失败:', error)
        alert('加载失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    viewProduct(product) {
      // 跳转到单个商品详情页
      this.$router.push({
        name: 'SharedProduct',
        params: { shareCode: product.shareCode || product.id }
      })
    },
    handleOrder(product) {
      // 检查登录状态
      const token = localStorage.getItem('auth_token')
      if (!token) {
        // 未登录，跳转登录页，携带分享code
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/order',
            shareCode: this.batchCode,
            productId: product.id
          }
        })
        return
      }
      // 已登录，跳转到下单页面
      this.$router.push({
        path: '/order',
        query: {
          batchCode: this.batchCode,
          productId: product.id
        }
      })
    }
  }
}
</script>

<style scoped>
.batch-share-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: calc(20px + env(safe-area-inset-top, 0px)) 16px;
  color: white;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wholesaler-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
}

.info .name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}

.info .desc {
  font-size: 13px;
  opacity: 0.9;
}

.product-list {
  padding: 16px;
}

.product-card {
  background: white;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image {
  font-size: 32px;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  min-width: 0;
}

.product-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-desc {
  font-size: 12px;
  color: #999;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.product-meta {
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #666;
}

.product-price {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.price-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.price-row .label {
  font-size: 11px;
  color: #999;
}

.price-row .price {
  font-size: 13px;
  font-weight: 600;
}

.price.market {
  color: #999;
  text-decoration: line-through;
}

.price.wholesale {
  color: #ff4d4f;
}

.product-action {
  flex-shrink: 0;
}

.btn-order {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-order:active {
  transform: scale(0.95);
  opacity: 0.9;
}

.empty-state {
  padding: 80px 20px;
  text-align: center;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #999;
}

.loading-state {
  padding: 80px 20px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: #999;
}
</style>
